import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Button, Modal, Spin, message } from "antd";
import { LoadingOutlined, MoreOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import liracrypt from "../../../Liracrypt/liracrypt";
import ZenModal from "../../../ZenModal";
import { useSelector } from "react-redux";
import ApiErrorComp from "../../../ApiErrorComp/ApiErrorComp";
import { createRoute } from "../../../../utils/CustomFunc";
import noImg from '../../../../assets/static/noImg.jpeg';
import { useLocation } from "react-router-dom";
import queryString from "query-string";

am4core.useTheme(am4themes_animated);

const ZenGanttChart = (props) => {
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const urlCode = useSelector(state => state.urlCode);
  const [chartConfig, setChartConfig] = useState();
  const [chartData, setChartData] = useState();
  const [zenModal, setZenModal] = useState();

  const [modal, setModal] = useState({
    type: "kanban",

    data: undefined,
    show: false,
    loading: false,
    zenModal: props.config?.zenPop,
  });

  const toggleModal = ({
    show = false,
    data = undefined,
    type = '',
    loading = false,
  }) => {
    setModal({ show, data, type, loading });
  };

  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);

  const createChart = (args, chart) => {
    if (args.data) {

      chart.data = args.data;
      chart.padding = args.config.chartDiv.padding;

      /* TITLE */
      if (args.config.title.enable === true) {
        var title = chart.titles.create();
        title.text = args.config.title.val;
        title.fontSize = args.config.title.fontSize;
        title.margin(
          args.config.title.margin[0],
          args.config.title.margin[1],
          args.config.title.margin[2],
          args.config.title.margin[3]
        );
        title.padding(
          args.config.title.padding[0],
          args.config.title.padding[1],
          args.config.title.padding[2],
          args.config.title.padding[3]
        );
        title.fontWeight = args.config.title.fontWeight;
        title.fill = args.config.title.color;
      }

      var categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = args.config.categoryAxis.categoryY;
      categoryAxis.renderer.line.strokeOpacity =
        args.config.categoryAxis.line.strokeOpacity;
      categoryAxis.renderer.line.strokeWidth =
        args.config.categoryAxis.line.strokeWidth;
      categoryAxis.renderer.line.stroke = am4core.color(
        args.config.categoryAxis.line.stroke
      );
      categoryAxis.renderer.labels.template.fontSize =
        args.config.categoryAxis.label.fontSize;
      categoryAxis.renderer.labels.template.fill =
        args.config.categoryAxis.label.color;
      categoryAxis.renderer.grid.template.strokeOpacity =
        args.config.categoryAxis.grid.strokeOpacity;
      categoryAxis.renderer.grid.template.stroke = am4core.color(
        args.config.categoryAxis.grid.stroke
      );
      categoryAxis.renderer.grid.template.strokeWidth =
        args.config.categoryAxis.grid.strokeWidth;
      categoryAxis.renderer.minGridDistance =
        args.config.categoryAxis.grid.minGridDistance;
      categoryAxis.renderer.labels.template.dx =
        args.config.categoryAxis.label.dx;
      categoryAxis.renderer.labels.template.dy =
        args.config.categoryAxis.label.dy;
      if (args.config.categoryAxis.label.wrap === true) {
        categoryAxis.renderer.labels.template.wrap = true;
        categoryAxis.renderer.labels.template.maxWidth =
          args.config.categoryAxis.label.maxWidth;
      }
      if (args.config.categoryAxis.label.truncate === true) {
        categoryAxis.renderer.labels.template.truncate = true;
        categoryAxis.renderer.labels.template.maxWidth =
          args.config.categoryAxis.label.maxWidth;
      }

      if (args.config.categoryAxis.label.orientation === "ang") {
        categoryAxis.renderer.labels.template.rotation = -45;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
      } else if (args.config.categoryAxis.label.orientation === "hor") {
        categoryAxis.renderer.labels.template.rotation = 0;
        categoryAxis.renderer.labels.template.horizontalCenter = "middle";
        categoryAxis.renderer.labels.template.verticalCenter = "top";
      } else if (args.config.categoryAxis.label.orientation === "ver") {
        categoryAxis.renderer.labels.template.rotation = -90;
        categoryAxis.renderer.labels.template.horizontalCenter = "middle";
        categoryAxis.renderer.labels.template.verticalCenter = "top";
      }

      categoryAxis.renderer.inversed = true;

      var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      chart.dateFormatter.inputDateFormat = args.config.dateAxis.dateFormat;

      dateAxis.dateFormatter.dateFormat = args.config.dateAxis.dateFormat;
      dateAxis.renderer.minGridDistance = args.config.dateAxis.minGridDistance;
      dateAxis.baseInterval = {
        count: args.config.dateAxis.baseInterval.count,
        timeUnit: args.config.dateAxis.baseInterval.timeUnit,
      };
      // dateAxis.max = new Date(2018, 0, 1, 24, 0, 0, 0).getTime();
      dateAxis.strictMinMax = true;
      dateAxis.renderer.tooltipLocation = 0;
      dateAxis.renderer.labels.template.fontSize =
        args.config.dateAxis.label.fontSize;
      dateAxis.renderer.labels.template.fill = args.config.dateAxis.label.color;
      //  args.config.valueLabel.color;


      //dateAxis.renderer.line.strokeOpacity = args.config.dateAxis.line.strokeOpacity;
      // dateAxis.renderer.line.strokeWidth = args.config.dateAxis.line.strokeWidth;
      // dateAxis.renderer.line.stroke = am4core.color(
      //   args.config.dateAxis.line.stroke
      // );
      dateAxis.renderer.line.strokeOpacity =
        args.config.dateAxis.line.strokeOpacity;
      dateAxis.renderer.line.strokeWidth =
        args.config.dateAxis.line.strokeWidth;
      dateAxis.renderer.line.stroke = am4core.color(
        args.config.dateAxis.line.stroke
      );

      dateAxis.renderer.grid.template.strokeOpacity =
        args.config.dateAxis.grid.strokeOpacity;
      dateAxis.renderer.grid.template.stroke = am4core.color(
        args.config.dateAxis.grid.stroke
      );
      dateAxis.renderer.grid.template.strokeWidth =
        args.config.dateAxis.grid.strokeWidth;


      if (args.config.dateAxis.enable === false) {
        dateAxis.renderer.labels.template.disabled = true;
      }



      if (args.config.dateAxis.label.orientation === "ang") {
        dateAxis.renderer.labels.template.rotation = -45;
        dateAxis.renderer.labels.template.horizontalCenter = "right";
        dateAxis.renderer.labels.template.verticalCenter = "middle";
      } else if (args.config.dateAxis.label.orientation === "hor") {
        dateAxis.renderer.labels.template.rotation = 0;
        dateAxis.renderer.labels.template.horizontalCenter = "middle";
        dateAxis.renderer.labels.template.verticalCenter = "top";
      } else if (args.config.dateAxis.label.orientation === "ver") {
        dateAxis.renderer.labels.template.rotation = -90;
        dateAxis.renderer.labels.template.horizontalCenter = "middle";
        dateAxis.renderer.labels.template.verticalCenter = "top";
      }

      let columnSeries = chart.series.push(new am4charts.ColumnSeries());
      columnSeries.columns.template.width = am4core.percent(
        args.config.columnSeries.columnWidth

      );
      columnSeries.columns.template.tooltipText = args.config.columnSeries.tooltipText;
      columnSeries.name = args.config.columnSeries.name;

      columnSeries.dataFields.openDateX = args.config.columnSeries.openDateX;
      columnSeries.dataFields.dateX = args.config.columnSeries.dateX;
      columnSeries.dataFields.categoryY = args.config.categoryAxis.categoryY;
      columnSeries.columns.template.propertyFields.fill = "color"; // get color from data
      columnSeries.columns.template.propertyFields.stroke = "color";
      columnSeries.columns.template.strokeOpacity = 1;

      columnSeries.columns.template.clickable = true;
      columnSeries.columns.template.fillOpacity =
        args.config.columnSeries.fill.fillOpacity;
      // columnSeries.columns.template.adapter.stroke.fill = "#ecf0f1"
      columnSeries.columns.template.column.strokeWidth =
        args.config.columnSeries.stroke.strokeWidth;
      columnSeries.columns.template.column.strokeOpacity =
        args.config.columnSeries.stroke.strokeOpacity;
      columnSeries.columns.template.column.stroke =
        args.config.columnSeries.stroke.color;

      columnSeries.columns.template.events.on(
        "hit",
        function (ev) {
          console.log(ev.target.dataItem.dataContext);
          if (args?.config?.zenPop?.typ === "comboRefresh") {
            if (props.onChange) {
              let urlData = args?.config?.zenPop?.params;
              let changeKey = args?.config?.zenPop?.comboRefreshId;
              urlData[changeKey] = ev.target.dataItem._id;
              props.onChange({
                apiUrl: args?.config?.zenPop?.api,
                urlData,
                changeKey,
              });
            }
          } else {
            onColumnClick(ev.target.dataItem.dataContext);
          }
        },
        this
      );
      if (args.config.columnSeries.shadow.enable === true) {
        var shadow = columnSeries.filters.push(new am4core.DropShadowFilter());
        shadow.dx = args.config.columnSeries.shadow.dx;
        shadow.dy = args.config.columnSeries.shadow.dy;
        shadow.blur = args.config.columnSeries.shadow.blur;
        chart.current = chart;
      }

      if (args.config.valueLabel.enable === true) {
        var valueLabel = columnSeries.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.fill = am4core.color(args.config.valueLabel.color);
        valueLabel.label.text = args.config.valueLabel.val;
        valueLabel.label.fontSize = args.config.valueLabel.fontSize;
        valueLabel.label.verticalCenter =
          args.config.valueLabel.verticalCenter;
        valueLabel.label.horizontalCenter =
          args.config.valueLabel.horizontalCenter;
        valueLabel.label.dx = args.config.valueLabel.dx;
        valueLabel.label.dy = args.config.valueLabel.dy;
      }

      categoryAxis.events.on("sizechanged", function (ev) {
        var axis = ev.target;
        // var cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex);
        if (args.config.categoryAxis.orientation === "ang") {
          axis.renderer.labels.template.rotation = -45;
          axis.renderer.labels.template.horizontalCenter = "right";
          axis.renderer.labels.template.verticalCenter = "middle";
        } else if (args.config.categoryAxis.orientation === "hor") {
          axis.renderer.labels.template.rotation = 0;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        } else if (args.config.categoryAxis.orientation === "ver") {
          axis.renderer.labels.template.rotation = -90;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        }
      });

      if (args.config.chartProp.scrollBar?.enable === true) {

        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarX.thumb.background.fill = am4core.color("#415162");
        chart.scrollbarX.thumb.background.fillOpacity = 0.2;
        chart.scrollbarX.startGrip.background.fill = am4core.color("#415162");
        chart.scrollbarX.endGrip.background.fill = am4core.color("#415162");
        chart.scrollbarX.thumb.background.fill = am4core.color("#415162");
        chart.scrollbarX.startGrip.icon.stroke = am4core.color("#415162");
        chart.scrollbarX.endGrip.icon.stroke = am4core.color("#415162");
        chart.scrollbarX.height = 1;
        chart.scrollbarX.stroke = am4core.color("#017acd");
      };
    }
  }


  const getApiChartData = (args) => {
    let params = { ...args?.params };
    liracrypt
      .get(props.api, { ...props.urlData, ...params })
      .then((response) => {
        console.log(response.data.data[props.divId]);
        if (!response.data.data[props.divId]) {
          return console.log("No Data Found");
        };
        if (props.setChartId) {
          props.setChartId(response.data.data[props.divId].meta._id);
        }
        if (props.setChartDataSource) {
          props.setChartDataSource(response.data.data[props.divId].meta.autoMan);
        }
        setChartData(response.data.data[props.divId]);
        // setTimeout(() => {
        //   chart = am4core.create(props.divId, am4charts.XYChart)
        //   createChart({
        //     data: response.data.data[props.divId].data,
        //     config: response.data.data[props.divId].config
        //   },
        //     chart);
        // }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.refreshChart) {
      getApiChartData();
    }
  }, [props.refreshChart])

  /* CHART CREATION */
  useEffect(() => {
    let chart = null;
    if (props.api) {
      setChartData(null);
      getApiChartData();
    } else if (props.data) {
      setChartData({ data: props.data, config: props.config });
      // setTimeout(() => {
      //   chart = am4core.create(props.divId, am4charts.XYChart)
      //   createChart({ data: props.data, config: props.config }, chart);
      // }, 500);
    }
  }, [props?.data]);

  useEffect(() => {
    var chart = null;
    if (chartData) {
      chart = am4core.create(props.divId, am4charts.XYChart);
      chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

      createChart({ data: chartData.data, config: chartData.config }, chart);
      return () => {
        chart.dispose();
      };
    }
  }, [chartData]);

  useEffect(() => {
    let interval;
    if (chartData?.config?.dataRefreshInterval) {
      interval = setInterval(() => {
        getApiChartData();
      }, chartData?.config?.dataRefreshInterval);
    };
    return () => clearInterval(interval);
  }, [chartData?.config?.dataRefreshInterval]);

  const zenPopupAction = (zenPopup, value, record) => {
    let urlData = { ...searchParams, ...props.urlData, ...zenPopup.params };
    if (zenPopup?.props) {
      urlData[zenPopup?.props] = value;
    }
    if (zenPopup?.multiProps) {
      zenPopup?.multiProps.forEach((prop) => {
        urlData[prop] = record[prop];
      });
    }
    if (zenPopup?.typ === 'smodal') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          id: value,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    };
    if (zenPopup?.typ === 'route') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          route: zenPopup?.route,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    }
    if (zenPopup?.api) {
      toggleModal({ show: true, loading: true, type: zenPopup?.typ });
      liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
        toggleModal({
          show: true,
          data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
          loading: false,
          type: zenPopup?.typ
        })
      });
      return;
    };
    return toggleModal({
      show: true,
      data: { data: zenPopup?.data, record },
      loading: false,
      type: zenPopup?.typ
    })
  }

  const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
    if (popData.method === 'GET') {
      liracrypt.get(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'POST') {
      liracrypt.post(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          console.log(err);
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'PATCH') {
      liracrypt.patch(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
  }

  const onColumnClick = (record) => {
    if (chartData?.config?.zenPop) {
      let zenPopDataIndex = { ...chartData?.config?.zenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  const onMenuClick = (record = {}) => {
    if (chartData?.config?.menuZenPop) {
      let zenPopDataIndex = { ...chartData?.config?.menuZenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  return (
    <div>
      {chartData ? (
        <>
          {
            chartData?.config?.menuZenPop?.enable ?
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={() => onMenuClick()} type="link" icon={
                  <MoreOutlined />}>{''}</Button>
              </div> : <></>
          }
          <div
            id={props.divId}
            style={chartData.config.chartDiv.style}
          ></div>
          <ZenModal
            modal={modal}
            toggleModal={toggleModal}
            smodalCallback={props.api ? getApiChartData : props.smodalCallback}
            refreshData={props.api ? (params) => getApiChartData({ params }) : (params) => props.refreshData({ ...params })}
            zenModal={zenModal}
          />
        </>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default ZenGanttChart;
